import { useEffect, useState } from "react";
import { storedLocale } from "../../../../Authentication/util";
import { useAppSelector } from "../../../../../store";
import { useGetLeadershipSeminarPathViewQuery } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI";
import type { LSPathViewResponse } from "../../../../../services/LeadershipSeminar/leadershipSeminarAPI.types";
import { QUALIFICATION_STATUS } from "../../../../../common/enums/incentive-enums";

const lsPathViewInitial: LSPathViewResponse = {
  Status: QUALIFICATION_STATUS.NOT_QUALIFIED,
  IsComingSoon: false,
  AutomaticallyApproved: false,
  ShowDateRangeError: false,
  StrategyName: "",
  TotalRequirements: 0,
  Path: [],
  Requirements: {
    Badge: [],
    RequalifiedBadge: [],
    Volume: [],
    MaintainFQOrGrowGPV: [],
    NewLeg: [],
    QCount: [],
  },
};

/**
 * Fetches the Leadership Seminar path view overview (used by markets such as Japan
 * whose LS incentive is configured for the path view, e.g. JP >= 202609).
 */
export const FetchLeadershipSeminarPathViewData = (period: string) => {
  const { user } = useAppSelector((state) => state.boot);
  const shellConfig = useAppSelector((state) => state.boot.shellConfig);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetLeadershipSeminarPathViewQuery({
    abo: user.abo,
    aff: user.aff,
    period,
    isoCountryCode: user.isoCountryCode,
    isoCurrencyCode: shellConfig.isoCurrencyCode,
    locale: storedLocale(),
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [lsPathViewData, setLsPathViewData] = useState<LSPathViewResponse>(lsPathViewInitial);

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (!isFetching && !isError && payloadData) {
      setLsPathViewData(payloadData);
    }
  }, [isFetching, period, isError, payloadData]);

  return { isLoading, lsPathViewData, errorStatus, refetch };
};
